import BaseModelAPI from '../BaseModelAPI';

export default class FinishGoodQcConfirmationDetail extends BaseModelAPI {
	static entity = 'finishgoodqcconfirmationdetail';
	static entityName = 'finishgoodqcconfirmationdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.finishGoodQcConfirmationId = '';
			this.finishGoodQcConfirmation = {};
			this.finishGoodQualityInspectionId = '';
			this.finishGoodQualityInspection = {};
			this.controlCardId = '';
			this.controlCard = {};
			this.partId = '';
			this.part = {};
			this.partName = '';
			this.metodeQc = '';
			this.qtyBefore = '';
			this.qtyOk = '';
			this.qtyPending = '';
			this.qtyNg = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}